import './App.css';
import { useLocalStorage } from "@uidotdev/usehooks";
import { useEffect, useState } from 'react'; 
import { encode, decode } from 'base64-arraybuffer';

function App() {
  const [soundData, setSoundData] = useState({
  });
  const [localSoundData, setLocalSoundData] = useLocalStorage(`soundData`, null);

  useEffect(() => {
    if (localSoundData) {
      console.log('loading localSoundData: ', localSoundData);
      const newSoundData = {};
      for (const key of Object.keys(localSoundData)) {
        newSoundData[key] = decode(localSoundData[key]);
      }
      setSoundData(newSoundData);
    }
  }, []);

  const getRows = () => {
    const rowCount = 3;
    const columnCount = 3;
    const rows = [];
  
    for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
      const row = [];
      for (let colIndex = 0; colIndex < columnCount; colIndex++) {
        row.push({
          colIndex,
          rowIndex,
        });
      }
      rows.push(row);
    }
  
    return rows;
  };
 
  const setSound = (cellId) => {
    let input = document.querySelector(`#${cellId}`);
    let files = input.files;
  
    if (files.length === 0) return;
  
    const file = files[0];
    let reader = new FileReader();
  
    reader.onload = (e) => {
      const result = e.target.result;
      const newSoundData = {
        ...soundData,
        [cellId]: result
      };
      setSoundData(newSoundData);
      const newLocalSoundData = {
        ...localSoundData,
        [cellId]: encode(result)
      }

      setLocalSoundData(newLocalSoundData);
    };
  
    reader.onerror = (e) => alert(e.target.error.name);
  
    reader.readAsArrayBuffer(file);
  }

  const playSound = (cellId) => {
    console.log('soundData =', soundData);
    const buffer = soundData[cellId];
    playSoundFromArrayBuffer(buffer);
  }

  const rows = getRows();

  return (
    <div className="App">
      <table>
        {
          rows.map(r => (
            <tr>
              {
                r.map(c => {
                  const cellId = `soundfile-${c.rowIndex}-${c.colIndex}`;
                  return (
                    <td>
                      <input onClick={() => playSound(cellId)} type="button" value="PLAY" />
                      <br />
                      <input id={cellId}
                        onChange={() => setSound(cellId)}
                        type="file" />
                    </td>
                  );
                })
              }
            </tr>
          ))
        }
      </table>
    </div>
  );
}

async function playSoundFromArrayBuffer(arrayBuffer) {
  const audioCtx = new (window.AudioContext || window.webkitAudioContext)();

  try {
    const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);

    const source = audioCtx.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(audioCtx.destination);
    source.start();

  } catch (error) {
    console.error('Error decoding audio data:', error);
  }
}

export default App;
